import './aui.page.reset';
import './aui.page.typography';
import './aui.page.links';
import '@atlassian/aui/src/less/aui-banner.less';
import '@atlassian/aui/src/less/adg-banner.less';
